import { HebrewCalendar, Location, flags } from '@hebcal/core';
const tzlookup = require('tz-lookup');


function getNextEvent(events,seek,flag)
{
    for(let i=seek; i<events.length; i++)
    {
        if(events[i].categorie === flag){
            return events[i];
        }
    }

    return null
}

export function getShabbatYomTovRanges(now=new Date(),lat, lon, isIsrael) {
    const tzid = tzlookup(lat, lon);
    const location = new Location(lat, lon, isIsrael ? 'Israel' : 'Diaspora', tzid);

    let events = HebrewCalendar.calendar({
        start: new Date(now.getTime() - 7 * 86400 * 1000),
        end: new Date(now.getTime() + 7 * 86400 * 1000),
        location: location,
        il: isIsrael,
        candlelighting: true,
        havdalah: true,
        noMinorFast: true,
        noModern: true,
        noSpecialShabbat: true,
        noRoshChodesh:true,
        omer:false,
        molad:false,
        sedrot:true,
        yomKippurKatan:false,
    });

    const ranges = [];

    const allowedCategories=["candles","parashat","havdalah"]
    events=events.map(e=>{

        let categories=e.getCategories()
        for(let ac of allowedCategories){
            if(categories.includes(ac)){
                e.categorie=ac
                break
            }
        }

        if(!e.categorie){
            const mask=e.getFlags()
            if ((mask & flags.CHAG) !== 0){
                e.categorie="holiday"
            }
        }

        if(!e.categorie){
            return null
        }

        return e
    }).filter(i=>i)

    //console.log("hebcal event",events)

    for(let i=0;i<events.length;i++){
        const event = events[i];

        if(event.categorie === "candles")
        {
            const havdalah=getNextEvent(events,i+1,"havdalah")
            if(havdalah){
                //console.log("havdalah",havdalah)
                ranges.push({
                    start:new Date(event.eventTime),
                    end:new Date(havdalah.eventTime),
                })
            }
        }
    }

    return ranges;
}